module.exports = __webpack_public_path__ + "static/media/expired.1d96ff9a.svg";